export const REFERENCE_NODE = ' ';
export const DEFAULT_PAGE_NAME = 'Untitled';
//# sourceMappingURL=consts.js.map